import { createTheme, adaptV4Theme } from "@mui/material/styles";

// USB color.
const theme = createTheme(adaptV4Theme({
  palette: {
    primary: {
      main: "#0c2074",
    },
    secondary: {
      main: "#1c2569",
    },
    error: {
      main: "#BE1324",
    },
    warning: {
      main: "#DE8600",
    },
    info: {
      main: "#3668DA",
    },
    success: {
      main: "#0A853D",
    },
  },
}));

export default theme;
